import React from "react";
import styled from "styled-components/native";
import { FooterProps } from "./types";
import Loader from "@components/atoms/Loader";

const FooterSpace = (props: FooterProps) => {
  const { backgroundColor } = props;

  return props.isLoader ? (
    <Container>
      <Loader backgroundColor={backgroundColor} />
    </Container>
  ) : (
    <ExtraContainer extraHeight={props.extraHeight} />
  );
};

const Container = styled.View`
  flex-direction: row;
  height: 60px;
  margin-bottom: 80px;
`;

const ExtraContainer = styled.View<any>`
  height: ${({ extraHeight }: { extraHeight?: number }) =>
    extraHeight ? extraHeight + "px" : "80px"};
`;

export default FooterSpace;
